import styled from 'styled-components';

export const LinkWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
